var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAltBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "56px",
    viewBox: "0 0 62 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Content/add_black_24dp/black")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[MVP]-Tablet-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assessments_default_Questionare_add-photo-modal",
    transform: "translate(-591.000000, -462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(450.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Secondary-Gray/Small/Icon-only/Default",
    transform: "translate(112.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/Content/add_black_24dp/black",
    transform: "translate(3.333333, 3.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 73.3333337 0 73.3333337 73.3333337 0 73.3333337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1111111,12.2222223 L51.4250002,12.2222223 L45.8333335,6.11111114 L27.5000001,6.11111114 L21.9083334,12.2222223 L12.2222223,12.2222223 C8.86111115,12.2222223 6.11111114,14.9722223 6.11111114,18.3333334 L6.11111114,55.0000002 C6.11111114,58.3611114 8.86111115,61.1111111 12.2222223,61.1111111 L61.1111111,61.1111111 C64.4722225,61.1111111 67.2222225,58.3611114 67.2222225,55.0000002 L67.2222225,18.3333334 C67.2222225,14.9722223 64.4722225,12.2222223 61.1111111,12.2222223 Z M61.1111114,55.0000002 L12.2222223,55.0000002 L12.2222223,18.3333334 L24.5972223,18.3333334 L30.188889,12.2222223 L43.1444446,12.2222223 L48.7361113,18.3333334 L61.1111114,18.3333334 L61.1111114,55.0000002 Z M36.6666668,21.388889 C28.2333335,21.388889 21.388889,28.2333335 21.388889,36.6666668 C21.388889,45.1000002 28.2333335,51.9444447 36.6666668,51.9444447 C45.1000002,51.9444447 51.9444447,45.1000002 51.9444447,36.6666668 C51.9444447,28.2333335 45.1000002,21.388889 36.6666668,21.388889 Z M36.6666668,45.8333335 C31.6250001,45.8333335 27.5000001,41.7083335 27.5000001,36.6666668 C27.5000001,31.6250001 31.6250001,27.5000001 36.6666668,27.5000001 C41.7083335,27.5000001 45.8333335,31.6250001 45.8333335,36.6666668 C45.8333335,41.7083335 41.7083335,45.8333335 36.6666668,45.8333335 Z",
    id: "Shape",
    fill: "#232323",
    fillRule: "nonzero"
  }))))))))));
}
export default SvgCameraAltBlack24Dp;